// Live Social Proof Stream
class LiveProofStream {
  constructor() {
    this.notification = document.getElementById('liveProofNotification');
    if (!this.notification) return;

    this.locations = [
      { city: 'Cape Town', country: 'ZA', emoji: '🇿🇦' },
      { city: 'Johannesburg', country: 'ZA', emoji: '🇿🇦' },
      { city: 'Durban', country: 'ZA', emoji: '🇿🇦' },
      { city: 'Pretoria', country: 'ZA', emoji: '🇿🇦' },
      { city: 'Port Elizabeth', country: 'ZA', emoji: '🇿🇦' }
    ];

    this.messages = [
      'just purchased this fragrance',
      'added this to cart',
      'is viewing this product',
      'just ordered this scent',
      'bought this perfume'
    ];

    this.init();
  }

  init() {
    // Show first notification after 8 seconds
    setTimeout(() => this.showNotification(), 80000000000);

    // Show subsequent notifications every 15-25 seconds
    setInterval(() => this.showNotification(), this.getRandomDelay(1500000000000000, 250000000000000000));

    // Close button
    const closeBtn = this.notification.querySelector('.pdp-live-proof__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hideNotification());
    }
  }

  showNotification() {
    if (this.notification.classList.contains('active')) return;

    const location = this.locations[Math.floor(Math.random() * this.locations.length)];
    const message = this.messages[Math.floor(Math.random() * this.messages.length)];
    const timeAgo = this.getRandomTimeAgo();

    this.notification.querySelector('.pdp-live-proof__location').textContent =
      `${location.emoji} ${location.city}`;
    this.notification.querySelector('.pdp-live-proof__text').textContent =
      `Someone ${message}`;
    this.notification.querySelector('.pdp-live-proof__time').textContent = timeAgo;

    this.notification.classList.add('active');

    // Auto-hide after 6 seconds
    setTimeout(() => this.hideNotification(), 6000);
  }

  hideNotification() {
    this.notification.classList.remove('active');
  }

  getRandomTimeAgo() {
    const minutes = Math.floor(Math.random() * 45) + 1;
    if (minutes === 1) return 'Just now';
    if (minutes < 5) return `${minutes} minutes ago`;
    return `${minutes} minutes ago`;
  }

  getRandomDelay(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new LiveProofStream());
} else {
  new LiveProofStream();
}